import "./MasterEditer.css";
import React, { useEffect, useState, useRef } from "react";


const MasterEditer=()=>{
    // モーダルエリアの表示・非表示を管理する state
    const [isModalVisible, setIsModalVisible] = useState(false);

function MasterEditer() {
    const tabContainerRef = useRef(null);
    useEffect(() => {
        const tabContainer = tabContainerRef.current;
        if (!tabContainer) return;
            const tabMenus = tabContainer.querySelectorAll(".tab__menu-item");
            const tabSwitch = (e) => {
            // クリックされた要素のデータ属性を取得
            const tabTargetData = e.currentTarget.dataset.tab;
            // クリックされた要素の親要素と、その子要素を取得
            const tabList = e.currentTarget.closest(".tab__menu");
            const tabItems = tabList.querySelectorAll(".tab__menu-item");
            // クリックされた要素の親要素の兄弟要素の子要素を取得
            const tabPanelItems =
            tabList.nextElementSibling.querySelectorAll(".tab__panel-box");
    
            // クリックされたtabの同階層のmenuとpanelのクラスを削除
            tabItems.forEach((tabItem) => {
            tabItem.classList.remove("is-active");
            });
            tabPanelItems.forEach((tabPanelItem) => {
            tabPanelItem.classList.remove("is-show");
            });
  
        // クリックされたmenu要素にis-activeクラスを付加
        e.currentTarget.classList.add("is-active");
        // クリックしたmenuのデータ属性と等しい値を持つパネルにis-showクラスを付加
        tabPanelItems.forEach((tabPanelItem) => {
            if (tabPanelItem.dataset.panel === tabTargetData) {
                    tabPanelItem.classList.add("is-show");
                }
                });
            };
  
      tabMenus.forEach((tabMenu) => {
        tabMenu.addEventListener("click", tabSwitch);
      });
  
      return () => {
        tabMenus.forEach((tabMenu) => {
          tabMenu.removeEventListener("click", tabSwitch);
        });
      };
    }, []
    );
};

    return (
    // {/* ◆◆◆◆◆◆main部 */}
        <div> 
            <iframe
            src="/00home/home.html"
            name="home"
            frameborder="0"
            width="100%"
            height="1000"
            id="iframe_right"
            ></iframe>
        </div>
    );

}

export default MasterEditer;